<mat-sidenav-container [hasBackdrop]="true">
  <mat-sidenav #drawer mode="over" [position]="'end'">
    <div class="ap-menu">
      <ul>
        <!-- <li>
          <a id="ap-menu-close" class="menu-close" (click)="drawer.toggle()">
            <i class="material-icons">keyboard_arrow_left</i>
          </a>
          <div class="separator"></div>
        </li> -->
        <li *ngFor="let menu of menuItems | async" [routerLink]="['./', menu.url]" class="ap-menu-link"
          (click)="drawer.toggle()" routerLinkActive="active">
          <div class="icon">
            <i class="material-icons">{{ menu.iconName }}</i>
          </div>
          {{ menu.name }}
        </li>
      </ul>
    </div>
    <div class="ap-menu-contact-details">
      <div>
        <span class="ap-email-logo">
          <span>
            <a href="mailto: {{'properties.generalEnquiryEmail' | content}}">{{'properties.navEmailLabel' | content}}</a>
          </span>
        </span>
      </div>
      <div class="ap-menu-phone">
        <div class="ap-phone-logo"></div>
        <div>
          <a href="tel:{{'properties.generalEnquiryPhone' | content}}">{{'properties.generalEnquiryPhone' | content}}</a>
        </div>
      </div>
    </div>
  </mat-sidenav>
  <mat-sidenav-content>
    <!-- Header -->
    <ap-header>
      <div class="ap-menu-mobile ap-mr-2" (click)="drawer.toggle()">
        <i class="material-icons">menu</i>
      </div>
      <ap-image class="ap-brand-image" [image]="'header.headerLogo'|content"></ap-image>
      <div class="ap-menu">
        <a *ngFor="let menu of menuItems | async"
           [routerLink]="['./', menu.url]"
           routerLinkActive="ap-active"
           [class.ap-sub-link-active]="menu.url === currentMenu?.parentUrl"
           class="ap-menu-link ap-ml-2">
          {{ menu.name }}
        </a>
      </div>
      <div class="ap-header-title ap-txt-right" *ngIf="(regioncode==='AUS')">{{ 'header.headerText'|content }}</div>
      <div class="ap-header-title ap-txt-right" *ngIf="(regioncode!='AUS')"> <ap-image class="ap-brand-imageright" [image]="'header.leftLogo'|content"></ap-image></div>
</ap-header>
    <article>
      <router-outlet></router-outlet>
    </article>
    <!-- Footer -->
    <ap-footer></ap-footer>
  </mat-sidenav-content>
</mat-sidenav-container>
